import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

// Silence diagnostic console output in production builds so user data,
// session info, and API payloads are not exposed via DevTools.
// console.error is intentionally preserved so real errors still surface.
// TEMP: bypass silencing when debugging event pages (?debugEvents=1, sessionStorage, or env).
function shouldSilenceProductionConsole() {
  if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined') {
    return false;
  }
  if (window.localStorage?.getItem('debug') === '1') {
    return false;
  }
  if (process.env.REACT_APP_DEBUG_EVENT_SHELL === 'true') {
    return false;
  }
  try {
    if (/[?&]debugEvents=1(?:&|$)/.test(window.location.search)) {
      return false;
    }
    if (window.sessionStorage?.getItem('ummahfyDebugEvents') === '1') {
      return false;
    }
  } catch (_) {
    /* blocked storage → keep silencing */
  }
  return true;
}

if (shouldSilenceProductionConsole()) {
  const noop = () => {};
  ['log', 'info', 'debug', 'warn', 'trace', 'dir', 'table', 'group', 'groupCollapsed', 'groupEnd']
    .forEach((m) => {
      if (typeof console[m] === 'function') console[m] = noop;
    });
}

// require('dotenv').config();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
